import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=bf195312&"
import script from "../../../services/layout/admin-sidebar.js?vue&type=script&lang=js&"
export * from "../../../services/layout/admin-sidebar.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports